import { defaultProducto, defaultSga, defaultAdjunto, defaultEpps } from "./state";

export function resetModal(state) {
  state.producto = defaultProducto()
  state.adjunto = defaultAdjunto()
  state.epps = defaultEpps()
  state.sga = defaultSga()
  state.empresa = {}
  state.empresas = []
  state.ubicaciones = []
  state.modal.paso = 0
  state.modal.ver = false
}

export function setModalVer(state, ver) {
  state.modal.ver = ver
}

export function setFabricantes(state, fabricantes) {
  state.fabricantes = fabricantes
}

export function setModalPaso(state, paso) {
  state.modal.paso = paso
}

export function setModalLoader(state, loader) {
  state.modal.loader = loader
}

export function setIdiomas(state, idiomas) {
  state.idiomas = idiomas
}

export function setTipos(state, tipos) {
  state.tipos = tipos
}

export function setEstadosFds(state, estados_fds) {
  state.estados_fds = estados_fds
}

export function setEmpresas(state, empresas) {
  state.empresas = empresas
}

export function setUbicaciones(state, ubicaciones) {
  state.ubicaciones = ubicaciones
}

export function addUbicacionSeleccionada(state, ubicacion) {
  state.ubicaciones_seleccionadas.push(ubicacion)
}

export function setUbicacionesSeleccionadas(state, ubicaciones) {
  state.ubicaciones_seleccionadas = ubicaciones
}

export function setCumpleDecretoAdjunto(state, cumple_decreto) {
  state.cumple_decreto = cumple_decreto
}

export function setUbicacionesEmpresa(state){
    state.empresas.map(e => {
      if (e.id === state.empresa.id){
        e.ubicaciones_seleccionadas = state.ubicaciones_seleccionadas
      }
    })
}

/**
 * Mutación para obtener los tipos de productos existentes
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} tipoProductos contiene la información de los tipos de productos.
 */
 export function setTipoProductos(state, tipoProductos) {
  state.tipoProductos = tipoProductos;
}

/**
 * Mutación que carga la informacion sga del sistema al formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} jsonSga contiene la informacion sga del sistema.
 */
 export function cargarJsonSga(state, jsonSga) {
  state.fisicos = jsonSga.fisicos;
  state.salud = jsonSga.salud;
  state.ambiental = jsonSga.ambiental;
  state.peligrosas = jsonSga.peligrosas;
}

/**
 * Establecer la nueva data para los componentes del producto.
 *
 * @param {*} state
 * @param {*} nextData
 * @author Fernando Claros
 */
export function setComponents(state, nextData) {
  state.components = nextData;
}


